import ModalDeleteFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import ModalSmallFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalVisibleHideQuoteProps extends ModalEditComponentProps {
    isHidden?: boolean
}

const ModalVisibleHideQuote: React.FC<ModalVisibleHideQuoteProps> = ({ setOpened, onSubmit, allRowData, isHidden }) => {
    if (isHidden) {
        return <ModalVisibleComment {...{ setOpened, onSubmit, allRowData }} />
    } else {
        return <ModalHideQuote {...{ setOpened, onSubmit, allRowData }} />
    }
}

type ModalVisibleQuoteProps = ModalVisibleHideQuoteProps
const ModalVisibleComment: React.FC<ModalVisibleQuoteProps> = ({ setOpened, allRowData, onSubmit }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/order/quote/comment/unhideQuoteOrderComment',
        data: allRowData || {}
    })

    return (
        <ModalSmallFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureMakeVisibleComment', '¿Seguro que quieres hacer visible este comentario?'),
            subtitle: t('CustomerWillReceiveNotificationToReadComment', 'El cliente recibirá una notificación y podrá leer el comentario'),
            buttonAccept: t('makeVisible', 'Hacer visible'),
        }} />
    )
}

const ModalHideQuote: React.FC<ModalVisibleHideQuoteProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/order/quote/comment/hideQuoteOrderComment',
        data: allRowData || {}
    })

    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureHideComment', '¿Seguro que quieres ocultar este comentario?'),
            subtitle: t('onceHiddenNotVisibleForCustomer', 'Una vez ocultado, el cliente no lo podrá ver'),
            buttonAccept: t('hide', 'Ocultar'),
            buttonCancel: t('return', 'Volver')
        }} />
    )
}

export default ModalVisibleHideQuote